var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "single-portfolio" }, [
    _c("div", { staticClass: "single-portfolio__slider" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row align-items-end" }, [
          _c(
            "div",
            { staticClass: "col-12 col-lg-10 offset-lg-1" },
            _vm._l(_vm.portfolio_entry.galerie, function(
              chapter,
              elementIndex
            ) {
              return _c(
                "div",
                {
                  staticClass: "single-portfolio__entry",
                  class: {
                    "single-portfolio__entry--disabled":
                      elementIndex !== _vm.index
                  },
                  style: { backgroundImage: "url(" + chapter.image.url + ")" }
                },
                [
                  _c("img", {
                    staticClass: "single-portfolio__image-min",
                    attrs: { src: chapter.image.url }
                  })
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "single-portfolio__buttons col-1" }, [
            _c("div", {
              staticClass:
                "single-portfolio__button single-portfolio__button--up",
              on: {
                click: function($event) {
                  return _vm.decreaseIndex()
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "single-portfolio__button single-portfolio__button--down",
              on: {
                click: function($event) {
                  return _vm.increaseIndex()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("h3", { staticClass: "single-portfolio__tag" }, [
              _vm._v(_vm._s(_vm.portfolio_entry.tags))
            ]),
            _vm._v(" "),
            _c("h2", { staticClass: "single-portfolio__title" }, [
              _vm._v(_vm._s(_vm.portfolio_entry.title))
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "single-portfolio__footer" }, [
      _c(
        "a",
        {
          staticClass: "single-portfolio__link",
          class: {
            "single-portfolio__link--disabled": _vm.previous_entry === null
          },
          attrs: { href: _vm.previous_entry }
        },
        [_vm._v("vorheriges Projekt")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "single-portfolio__switcher" },
        _vm._l(_vm.numberOfImages, function(x, number) {
          return _c(
            "div",
            { staticClass: "single-portfolio__switcher-entry" },
            [
              _c("div", {
                staticClass: "single-portfolio__switcher-bar",
                class: {
                  "single-portfolio__switcher-bar--active": number === _vm.index
                }
              })
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "single-portfolio__link single-portfolio__link--next",
          class: {
            "single-portfolio__link--disabled": _vm.next_entry === null
          },
          attrs: { href: _vm.next_entry }
        },
        [_vm._v("nächstes Projekt")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d83fe9be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/fabianschneider/Documents/Development/code/wordpress/lineabertoli/web/app/themes/lineabertoli/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d83fe9be","hasScoped":false,"buble":{"transforms":{}}}!/Users/fabianschneider/Documents/Development/code/wordpress/lineabertoli/web/app/themes/lineabertoli/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/single-portfolio.vue
// module id = 36
// module chunks = 0